import React, { useEffect, useState } from 'react';
import { Col, Row, Tooltip, Select, Spin } from 'antd';
import { isEmpty } from 'lodash';

import Modal from "../../components/uiComponent/modal/index";
import Input from '../../components/uiComponent/inputs/labelInput';

import InventoryWrapper from './style';
import { EditItemQuantity, updateMappedQuantity } from '../../slices/3-layer-products';
import { useDispatch, useSelector } from 'react-redux';
import { copyToClip } from '../../utils/utils';
import { STORAGE_IMAGE_URL } from '../../constants/storage';

const ProductImg = `${STORAGE_IMAGE_URL}/newImages/nestle.svg`;
const copyIcon = `${STORAGE_IMAGE_URL}/newImages/copy-white-icon.svg`;

const { Option } = Select;

const EditSkuQtyModal = ({ open, onHide, expandRow, productData, skuIndex, sellerSkus, handleShowMappingAlert }) => {
  const dispatch = useDispatch();

  const [selectedSku, setSelectedSku] = useState(null);
  const [quantity, setQuantity] = useState("");

  const {
    editingItemQuantity
  } = useSelector((state) => state.threeLayerProducts || {});

  useEffect(() => {
    setSelectedSku({ value: { key: skuIndex, label: sellerSkus[skuIndex]?.sku } });
    setQuantity(sellerSkus[skuIndex]?.product_sku_mappings_v2?.bundle_quantity);
  }, [sellerSkus]);

  return (
    <Modal
      open={open}
      onHide={onHide}
      size="lg"
      closeText="Cancel"
      saveText="Confirm"
      header={true}
      closeButton={true}
      onClose={onHide}
      onSave={() => {
        dispatch(EditItemQuantity({
          sku_id: sellerSkus[skuIndex].id,
          product_id: productData.id,
          quantity
        })).then(({ payload }) => {
          if (payload?.success) {
            dispatch(updateMappedQuantity({ field: 'products', parentId: productData.id, key: 'seller_skus', childId: sellerSkus[skuIndex].id, value: quantity }));
            expandRow(productData.id);
            onHide();
          }
          else if (!isEmpty(payload?.errorData)) handleShowMappingAlert();
        });
      }}
      buttonDisabled={!quantity || quantity <= 0}
    >
      <InventoryWrapper className='sku-modal'>
        <Spin tip='Loading...' spinning={editingItemQuantity}>
          <h4 className='text-primary fw-bold mb-3'>Edit Mapping</h4>
          <div className="product-title mb-4">
            <img src={productData.image_url || ProductImg} alt="product" width={28} height={28} className='product-img' />
            <div className='w-100'>
              <Tooltip placement="bottom" title={productData.name}>
                <span className="product-name">{productData.name}</span>
              </Tooltip>
              <div className='asin'>
                <span>{productData.identifier_value}</span>
                <img src={copyIcon} alt='copy' className='cursor-pointer'
                  onClick={() => copyToClip(productData.identifier_value)}
                />
              </div>
            </div>
          </div>
          <Row gutter={24} className='mb-5'>
            <Col span={11}>
              <div className='search-sku'>
                <label>Search SKUs</label>
                <Select
                  showSearch
                  placeholder="Select"
                  style={{ width: "100%" }}
                  value={selectedSku?.value}
                  onChange={(value, option) => {
                    setSelectedSku({ value, label: option.label });
                  }}
                  labelInValue
                  optionLabelProp="label"
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  disabled={true}
                >
                  {sellerSkus.map((item, index) => (
                    <Option key={index} value={item.id} label={item.sku}>
                      <div className="product-title option-product w-100">
                        <img src={item.image_url || ProductImg} alt="product" width={36} height={36} className='product-img' />
                        <div className='w-100'>
                          <Tooltip placement="bottom" title={item.item_name}>
                            <span className="product-name">{item.item_name}</span>
                          </Tooltip>
                          <div className='d-flex gap-2'>
                            <div className='asin'>
                              <span>{item.sku}</span>
                            </div>
                            <div className='asin'>
                              <span>{item?.vendorasin?.asin}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Option>
                  ))}
                </Select>
              </div>
            </Col>
            <Col span={13}>
              <div className='d-flex align-items-end gap-3 add-sku-btn'>
                <Input
                  placeholder="Enter"
                  value={quantity}
                  type="number"
                  onChange={(e) => setQuantity(e.target.value)}
                  label="Quantity"
                  width="80%"
                  marginBottom="0"
                />
              </div>
            </Col>
          </Row>
        </Spin>
      </InventoryWrapper>
    </Modal>
  );
};

export default EditSkuQtyModal;
